import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest } from '../../../common/Common';
import { getTotal, sanitizeList } from '../../../common/Util';
import { TARGET_YEAR_API } from '../../../common/data';
// import { filterNonItemList } from './util';

const initialState = {
  isRender: false,
  reload: -1,
  dataList: [],
  //공제 불가 항목
  nonItemList: [],
  //원본데이터
  originalDataList: [],

  // 합계
  total: 0,
  //급여
  salary: 0,
};

//신용카드 불러오기
export const getCreditCardsInfo = createAsyncThunk('creditCards/getCreditCardsInfo', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S9`);
  return response;
});

const creditCardsSlice = createSlice({
  name: 'creditCardsSlice',
  initialState,
  reducers: {
    setReload: (state, action) => {
      state.reload = Math.random();
    },

    resetCreditCardsState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getCreditCardsInfo.pending, state => {
      // state.dataList = [];
      // state.nonItemList = [];
      state.isRender = false;
    });
    builder.addCase(getCreditCardsInfo.fulfilled, (state, action) => {
      console.log('신용카드 리스트 >>', action.payload);
      const { list, htm013 } = action.payload;
      if (htm013) state.salary = htm013;
      else state.salary = 0;
      if (list) {
        state.dataList = list;
        let totalList = list.filter(item => {
          return item.deType == '1';
        });
        state.total = getTotal(totalList, ['sinYongSum']);
      } else {
        state.dataList = [];
        state.total = 0;
      }
      state.isRender = true;
    });
  },
});

export const { resetCreditCardsState, setReload } = creditCardsSlice.actions;
export default creditCardsSlice.reducer;
